import { ResizableModule } from 'angular-resizable-element';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormColorPickerModule } from '@lib/form/color-picker';
import { SnFormToggleTooltipModule } from '@lib/form/toggle-tooltip';
import { GoogleMapModule } from '@lib/geo/google/map';
import { SnMapModule } from '@lib/geo/map';
import { TranslationModule } from '@lib/translation';
import { BannerMessageModule } from '@lib/ui/banner-messages';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnSearchbarModule } from '@lib/ui/searchbar';
import { SnActionsModule } from 'libs/ui/actions/src/lib/actions.module';

import { AddHotlistGroupDialogComponent } from './components/add-hotlist-group-dialog/add-hotlist-group-dialog.component';
import { AddLprhotlistFormComponent } from './components/add-lprhotlist-form/add-lprhotlist-form.component';
import { AddPlateToGroupDialogComponent } from './components/add-plate-to-group-dialog/add-plate-to-group-dialog.component';
import { AddReasonOptionDialogComponent } from './components/add-reason-option-dialog/add-reason-option-dialog.component';
// ALPR Alert Components
import { AlprHitDetailsCardComponent } from './components/alpr-alerts/alpr-hit-details-card/alpr-hit-details-card.component';
import { LicensePlateDetailsComponent } from './components/alpr-alerts/alpr-hit-details-card/license-plate-details.component';
import { AlprMediaCardComponent } from './components/alpr-alerts/alpr-media-card/alpr-media-card.component';
import { FullscreenIconComponent } from './components/alpr-alerts/alpr-media-card/fullscreen-icon.component';
import { AlprReadsSearchComponent } from './components/alpr-reads-search/alpr-reads-search.component';
import { LPRSourceSelectComponent } from './components/alpr-reads-search/source-management/components';
import { CsvExportDialogComponent } from './components/csv-export-dialog/csv-export-dialog.component';
import { FleetQueryPlateCardDetailsComponent } from './components/fleet-query-plate-card-details/fleet-query-plate-card-details.component';
import { FleetQueryPlateCardComponent } from './components/fleet-query-plate-card/fleet-query-plate-card.component';
import { FleetQueryTableComponent } from './components/fleet-query-table/fleet-query-table.component';
import { FlockQueryPlateCardComponent } from './components/flock-query-plate-card/flock-query-plate-card.component';
import { ImageLightboxViewerComponent } from './components/image-lightbox-viewer/image-lightbox-viewer.component';
import { LprAuditDialogComponent } from './components/lpr-audit-dialog/lpr-audit-dialog.component';
import { LprCameraDetailsPopupComponent } from './components/lpr-camera-details-popup/lpr-camera-details-popup.component';
import { LprCameraStatsDialogComponent } from './components/lpr-camera-stats-dialog/lpr-camera-stats-dialog.component';
import { LprCameraTableExpandedComponent } from './components/lpr-camera-table-expanded/lpr-camera-table-expanded.component';
import { LprCameraTableComponent } from './components/lpr-camera-table/lpr-camera-table.component';
import { LprHotlistGroupsComponent } from './components/lpr-hotlist-groups/lpr-hotlist-groups.component';
import { LprHotlistsListComponent } from './components/lpr-hotlists-list/lpr-hotlists-list.component';
import { LprHotlistsPlatesDialogComponent } from './components/lpr-hotlists-plates-dialog/lpr-hotlists-plates-dialog.component';
import { LprHotlistsPlatesTableComponent } from './components/lpr-hotlists-plates-table/lpr-hotlists-plates-table.component';
import { LprHotlistsTableComponent } from './components/lpr-hotlists-table/lpr-hotlists-table.component';
import { LprPlateImageDialogComponent } from './components/lpr-plate-image-dialog/lpr-plate-image-dialog.component';
import { LprQueryCameraFormComponent } from './components/lpr-query-camera-form/lpr-query-camera-form.component';
import { IncomingTableComponent } from './components/lpr-sharing-management/incoming/incoming-table.component';
import { LprSharingManagementComponent } from './components/lpr-sharing-management/lpr-sharing-management.component';
import { OutgoingTableComponent } from './components/lpr-sharing-management/outgoing/outgoing-table.component';
import { LprViewStagesComponent } from './components/lpr-view-stages/lpr-view-stages.component';
import { ManageInternalHotlistDialogComponent } from './components/manage-internal-hotlist-dialog/manage-internal-hotlist-dialog.component';
import { ManageLprGroupDialogComponent } from './components/manage-lpr-group-dialog/manage-lpr-group-dialog.component';
import { PlateCardComponent } from './components/plate-card/plate-card.component';
import { SnPlateFormDialogComponent } from './components/plate-form-dialog/plate-form-dialog.component';
import { PlateInfoPopupComponent } from './components/plate-info-popup/plate-info-popup.component';
import { PlateMapComponent } from './components/plate-map/plate-map.component';
import { PlatesRedirectComponent } from './components/plates-redirect/plates-redirect.component';
import { QueryResultsMapViewComponent } from './components/query-results-map-view/query-results-map-view.component';
import { RecentHitDialogComponent } from './components/recent-hits-dialog/recent-hit-dialog.component';
import { ResultMapHeatmapComponent } from './components/result-map-heatmap/result-map-heatmap.component';
import { SearchReasonDialogComponent } from './components/search-reason-dialog/search-reason-dialog.component';

@NgModule({
  imports: [
    SnFormModule,
    SnFormToggleTooltipModule,
    SnFormColorPickerModule,
    SnDrawerModule,
    CommonModule,
    FormsModule,
    MatIconModule,
    ReactiveFormsModule,
    DragDropModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NgxLoadingButtonsModule,
    ClipboardModule,
    ResizableModule,
    TranslationModule,
    SnCommonModule,
    SnButtonModule,
    SnDataListModule,
    SnIconModule,
    SnListModule,
    SnSearchbarModule,
    SnActionsModule,
    SnMapModule,
    GoogleMapModule,
    BannerMessageModule,
    MatCheckboxModule,
    MatInputModule,
    MatChipsModule,
    TranslationModule,
    LPRSourceSelectComponent,
  ],
  exports: [
    SearchReasonDialogComponent,
    PlatesRedirectComponent,
    AddLprhotlistFormComponent,
    AddPlateToGroupDialogComponent,
    AddHotlistGroupDialogComponent,
    AddReasonOptionDialogComponent,
    FleetQueryPlateCardComponent,
    FleetQueryTableComponent,
    FlockQueryPlateCardComponent,
    ImageLightboxViewerComponent,
    LprAuditDialogComponent,
    LprCameraDetailsPopupComponent,
    LprCameraTableComponent,
    LprCameraTableExpandedComponent,
    LprHotlistGroupsComponent,
    LprHotlistsListComponent,
    LprHotlistsPlatesDialogComponent,
    LprHotlistsPlatesTableComponent,
    LprHotlistsTableComponent,
    LprPlateImageDialogComponent,
    LprQueryCameraFormComponent,
    ManageInternalHotlistDialogComponent,
    ManageLprGroupDialogComponent,
    PlateCardComponent,
    QueryResultsMapViewComponent,
    PlateInfoPopupComponent,
    PlateMapComponent,
    SnPlateFormDialogComponent,
    RecentHitDialogComponent,
    ResultMapHeatmapComponent,
    FleetQueryPlateCardDetailsComponent,
    LprViewStagesComponent,
    AlprReadsSearchComponent,
    LprCameraStatsDialogComponent,
    // ALPR Alert Components
    AlprHitDetailsCardComponent,
    AlprMediaCardComponent,
    LicensePlateDetailsComponent,
    FullscreenIconComponent,
    LprSharingManagementComponent,
    OutgoingTableComponent,
    IncomingTableComponent,
  ],
  declarations: [
    SearchReasonDialogComponent,
    CsvExportDialogComponent,
    PlatesRedirectComponent,
    AddLprhotlistFormComponent,
    AddPlateToGroupDialogComponent,
    AddHotlistGroupDialogComponent,
    AddReasonOptionDialogComponent,
    FleetQueryPlateCardComponent,
    FleetQueryTableComponent,
    FlockQueryPlateCardComponent,
    ImageLightboxViewerComponent,
    LprAuditDialogComponent,
    LprCameraDetailsPopupComponent,
    LprCameraTableComponent,
    LprCameraTableExpandedComponent,
    LprHotlistGroupsComponent,
    LprHotlistsListComponent,
    LprHotlistsPlatesDialogComponent,
    LprHotlistsPlatesTableComponent,
    LprHotlistsTableComponent,
    LprPlateImageDialogComponent,
    LprQueryCameraFormComponent,
    ManageInternalHotlistDialogComponent,
    ManageLprGroupDialogComponent,
    PlateCardComponent,
    QueryResultsMapViewComponent,
    PlateInfoPopupComponent,
    PlateMapComponent,
    SnPlateFormDialogComponent,
    RecentHitDialogComponent,
    ResultMapHeatmapComponent,
    FleetQueryPlateCardDetailsComponent,
    LprViewStagesComponent,
    AlprReadsSearchComponent,
    LprCameraStatsDialogComponent,
    AlprHitDetailsCardComponent,
    AlprMediaCardComponent,
    LicensePlateDetailsComponent,
    FullscreenIconComponent,
    LprSharingManagementComponent,
    OutgoingTableComponent,
    IncomingTableComponent,
  ],
})
export class VehicleIntelligenceModule {}
